import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-text-input-dialog',
    imports: [MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule],
    templateUrl: './text-input-dialog.component.html',
    styleUrl: './text-input-dialog.component.scss'
})
export class TextInputDialogComponent {
  inputValue: string = this.data.value || '';

  constructor(
    public dialogRef: MatDialogRef<TextInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close(this.inputValue);
  }
}

